import Vue from 'vue'
import Vuex from 'vuex'
import scheduler from '../store/scheduler'
import auth from '../store/auth'
import {SchedulerHelper} from "../helpers/SchedulerHelper";

const helper = new SchedulerHelper();

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {scheduler, auth},
  state: {
    user: null,
    loggedIn: false,
    authChecked: false,
    inspections: [],
    showSnackbar: false,
    snackbarMsg: '',
    snackbarColor: '',
    inspectionSheetOpen: false,
    showWhatsNew: false,
    sessionRefreshed: Date.now(),
    platform: 'desktop',
  },
  mutations: {
    setInspections: (state, payload) => state.inspections = payload,
    setLoggedIn: (state, payload) => {
      state.loggedIn = true
      state.user = payload
    },
    setLoggedOut: (state) => {
      state.user = null
      state.loggedIn = false
      state.inspections = []
    },
    setAuthChecked(state, payload) {
      state.authChecked = payload
    },
    setShowSnackbar: (state, payload) => state.showSnackbar = payload,
    setSnackbarMsg: (state, payload) => state.snackbarMsg = payload,
    setSnackbarColor: (state, payload) => state.snackbarColor = payload,
    setInspectionSheetOpen: (state, payload) => state.inspectionSheetOpen = payload,
    setShowWhatsNew: (state, payload) => state.showWhatsNew = payload,
    setSessionRefreshed: (state, payload) => state.sessionRefreshed = payload,
    setPlatform(state, payload) {
      state.platform = payload
      const viewport = document.querySelector('#viewport')
      viewport.content = state.platform === 'mobile'
          ? 'width=device-width, initial-scale=1.0, user-scalable=no'
          : ''
      localStorage.setItem('platform', state.platform)
    },
    togglePlatform() {
      const platform = this.state.platform === 'mobile' ? 'desktop' : 'mobile'
      this.commit('setPlatform', platform)
    }
  },
  actions: {
    retrieveInspections({commit}, {options, search, when}) {
      return this._vm.$axios.get(`/api/inspections`, {params: {page: options.page, options, search, when}})
          .then(response => commit('setInspections', response.data))
    },
    retrieveLogs(_, id) {
      return this._vm.$axios.get(`/api/inspections/logs/${id}`)
    },
    retrieveSheetData(_, id) {
      return this._vm.$axios.get(`/api/inspections/sheet/${id}`)
    },
    retrieveInspectors() {
      return this._vm.$axios.get('api/inspectors')
    },
    retrieveEvents(_, {start, end}) {
      return this._vm.$axios.get('api/events', {params: {start, end}})
    },
    retrieveInspectorColors() {
      return this._vm.$axios.get('api/inspectors/colors')
    },
    putInspectorColors(_, {inspectorId, color}) {
      return this._vm.$axios.put(`api/inspectors/colors/${inspectorId}`, {color})
    },
    postCalendarEvent(_, calendarEvent) {
      return this._vm.$axios.post('api/events', helper.getCalendarEventPayload(calendarEvent))
    },
    putCalendarEvent(_, calendarEvent) {
      let id = calendarEvent.Id.slice(6)
      return this._vm.$axios.put(`api/events/${id}`, helper.getCalendarEventPayload(calendarEvent))
    },
    deleteCalendarEvent(_, calendarEvent) {
      let id = calendarEvent.Id.slice(6)
      return this._vm.$axios.delete(`api/events/${id}`)
    },
    putSchedulerSettings(_, payload) {
      return this._vm.$axios.put(`api/inspectors/settings`, payload)
    },
  },
  getters: {
    getInspections: state => state.inspections,
    isLoggedIn: state => (state.loggedIn === true),
    getUser: state => state.user,
    getShowSnackbar: state => state.showSnackbar,
    getSnackbarMsg: state => state.snackbarMsg,
    getSnackbarColor: state => state.snackbarColor,
    inspectionSheetOpen: state => state.inspectionSheetOpen,
    showWhatsNew: state => state.showWhatsNew,
    sessionRefreshed: state => state.sessionRefreshed,
    platform: state => state.platform,
    authChecked: state => state.authChecked,
  }
})